import React, { StrictMode, useEffect, useLayoutEffect, useState, useContext, useRef } from 'react';
import { ContextWrapper, AppContext } from "./context/AppContext.jsx";
import { BrowserRouter, Route, Routes, useLocation, useParams, useNavigate } from 'react-router-dom';
import { FiltersProvider } from './context/FiltersContext.jsx';

//import 'vanilla-cookieconsent/dist/cookieconsent.css';
//import CookieConsentComponent from './components/CookieConsent.jsx';
//import CookieConsentControls from './components/CookieConsentApiControls.jsx';

import { showMain, hideMain } from './helpers/helperFunctions.js';
import Header from './components/Header.jsx';
import Home from './templates/Page/HomeTemplate.jsx';
import Footer from './components/Footer.jsx';
import PageRouter from './components/PageRouter.jsx';
import SiteLoader from './components/SiteLoader.jsx';
import gsap from 'gsap';
import { ScrollSmoother } from '../gsap/ScrollSmoother.min.js';

gsap.registerPlugin(ScrollSmoother);


import { useLanguage, LanguageProvider } from "./i18n/LanguageContext.jsx";
import i18n from "./i18n/i18n";

//gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function App() {
	return (
		<LanguageProvider>
			<ContextWrapper>
				<BrowserRouter>
					<FiltersProvider>
						<AppContent />
					</FiltersProvider>
				</BrowserRouter>
			</ContextWrapper>
		</LanguageProvider>
		/*<div className="coming-soon"></div>*/ //TODO: REMOVE
	);
}

function AppContent() {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const { language } = useLanguage();
	const { siteMap, setError } = useContext(AppContext);
	let smoother = null;

	useEffect(() => {
		//if (!siteMap) return;
		hideMain();
		window.scrollTo({ top: 0, left: 0, behavior: "instant" })
		document.querySelector("header").classList.remove("header-small")
		document.querySelector("header").classList.remove("header-collapse")
	}, [window.location.pathname, window.location.search]);


	useEffect(() => {
		setTimeout(() => {
			window.scrollTo({ top: 0, left: 0, behavior: "instant" })
			showMain();
		}, 200)

	}, [location, window.location.pathname, window.location.search]);


	useEffect(() => {
		if (smoother) {
			smoother.refresh();
			smoother.scrollTo(0)
		} else if (siteMap) {
			smoother = ScrollSmoother.create({
				smooth: 1,
				effects: false,
			});
			smoother.scrollTo(0)
		}

		return () => {
			if (smoother) {
				smoother.kill();
			}
		};
	}, [window.location.pathname, window.location.search, siteMap]);


	useEffect(() => {
		setError(null)
	}, [location, window.location.pathname, window.location.search])

	return (
		<>
			<SiteLoader />
			<Header />
			<div id="smooth-wrapper">
				<div id="smooth-content">
					<main>
						<Routes>
							<Route path={`/${language}`} exact element={<Home />} />
							<Route path={`/${language}/*`} exact element={<PageRouter />} />
						</Routes>
					</main>
					<Footer />
				</div>
			</div> 
			{/* <CookieConsentComponent /> */}
		</>
	);
}

export default App;
 